import Container from '@/components/@base/container';
import XImage from '@/components/@base/x-image';
import DiscountedProductCard from '@/components/shared/components/developer-discount-codes/discounted-product-card';
import RateInfo from '@/components/shared/components/developer-discount-codes/rate-info';
import SalesInfo from '@/components/shared/components/developer-discount-codes/sales-info';

import { DATA_CY_STORE_DISCOUNT_ITEM } from '@/constant/cypress';
import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';
import VendorVoucherModel from '@/models/vendor-voucher.model';

type Props = {
  data: VendorVoucherModel;
};

export default function DiscountedCodesCard({ data }: Props) {
  const { store: storeLocalization } = pageLevelLocalization;
  return (
    <Container
      id='developerDiscountSection'
      data-cy={DATA_CY_STORE_DISCOUNT_ITEM}
      className='mx-3 mt-4 flex flex-col gap-8 pt-3 md:mx-0 md:flex-row'
    >
      <Container className='w-full md:w-[68%]'>
        <DiscountedProductCard product={data} />
      </Container>
      <Container className='flex w-full items-stretch justify-evenly md:w-[32%] lg:flex-col'>
        <SalesInfo
          saleAmount={data?.saleAmount}
          successfulSale={storeLocalization.successful_sale}
        />
        <XImage
          alt='guarantee'
          width={70}
          height={60}
          src={imagesList.icons.guarantee}
          className='flex md:hidden'
        />
        <RateInfo
          rateAverage={data?.rate?.rateAverage}
          averageUserRating={storeLocalization.average_user_rating}
        />
      </Container>
    </Container>
  );
}
